export default function Custom500() {
  return (
    <>
      <style jsx>
        {`
          h1 {
            color: var(--color-font-black);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        `}
      </style>
      <h1>500 - Server-side error occurred</h1>
    </>
  );
}
